(() => {
  const desktopQuery = window.matchMedia('(min-width: 1000px)');

  const prepareMobileParentLinks = () => {
    document
      .querySelectorAll('.header__dropdown-menu details > summary[data-follow-link]')
      .forEach((summary) => {
        if (summary.dataset.tosMobileParentReady === 'true') return;

        const stack = summary.querySelector('.h-stack');
        const url = summary.dataset.followLink;
        if (!stack || !url) return;

        const title = summary.textContent.trim();
        const icon = stack.querySelector('svg');
        const link = document.createElement('a');

        link.href = url;
        link.textContent = title;
        link.className = 'grow';
        link.dataset.tosMobileParentLink = 'true';

        link.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.href = link.href;
        });

        stack.replaceChildren(link);

        if (icon) {
          stack.appendChild(icon);
        }

        summary.dataset.tosMobileParentReady = 'true';
      });
  };

  const syncMegaMenu = (menu) => {
    const nestedMenus = menu.querySelectorAll(':scope > .header__dropdown-menu details');

    nestedMenus.forEach((details) => {
      details.open = desktopQuery.matches && menu.open;
    });
  };

  const initialise = () => {
    document
      .querySelectorAll('.header__primary-nav-item > dropdown-menu-disclosure > details')
      .forEach((menu) => {
        if (menu.dataset.tosMegaMenuReady !== 'true') {
          menu.dataset.tosMegaMenuReady = 'true';
          menu.addEventListener('toggle', () => syncMegaMenu(menu));
        }

        syncMegaMenu(menu);
      });

    prepareMobileParentLinks();
  };

  if (document.documentElement.dataset.tosSecondLevelLinksReady !== 'true') {
    document.documentElement.dataset.tosSecondLevelLinksReady = 'true';

    document.addEventListener('click', (event) => {
      if (!desktopQuery.matches) return;

      const desktopLink = event.target.closest(
        '.header__dropdown-menu details > a[href]'
      );

      if (!desktopLink) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.href = desktopLink.href;
    }, true);
  }

  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('DOMContentLoaded', initialise);
  desktopQuery.addEventListener('change', initialise);
  initialise();
})();
